import { Spin } from "antd";
import { FunctionComponent } from "react";

interface SplashScreenProps {}

const SplashScreen: FunctionComponent<SplashScreenProps> = () => {
  return (
    <div className="splash-screen">
      <Spin tip="Loading gear..." />
    </div>
  );
};

export default SplashScreen;
